import React from 'react';
import {
	TextComponent,
	BannerComponent,
	MainBannerComponent,
	ServicesBlockComponent,
	SliderComponent,
	MemberComponent,
	TextMediaComponent,
	ContactFormComponent,
} from '../../../../common/CMS/components';

export const Media1 = props => {
	const isPartnerFBRH = () => {
		let slug = window.location.pathname;
		return slug.includes('fbrh');
	};

	let data = props.data && props.data.content ? props.data.content : props.data;
	const {
		mainBannerSection,
		bannerSection,
		contactFormSection,
		mediaSection,
		memberSection,
		servicesBlockSection,
		sliderSection,
		textSectionOne,
	} = data;

	const partnerContent = () => {
		return (
			<div className="row media-one">
				{mainBannerSection && (
					<MainBannerComponent content={mainBannerSection} />
				)}

				{mediaSection && <TextMediaComponent content={mediaSection} />}

				{servicesBlockSection && (
					<ServicesBlockComponent content={servicesBlockSection} />
				)}

				{contactFormSection && (
					<ContactFormComponent contactForm={contactFormSection} />
				)}

				{sliderSection && <SliderComponent images={sliderSection.images} />}

				{textSectionOne && <TextComponent content={textSectionOne.columns} />}

				{memberSection && <MemberComponent content={memberSection} />}

				{bannerSection && <BannerComponent {...bannerSection} />}
			</div>
		);
	};

	const fbrhContent = () => {
		return (
			<a
				href={props.data.content.mediaSection.button.link}
				rel="noopener noreferrer"
			>
				<img
					className="partner-full-img"
					src={props.data.content.mediaSection.image}
					alt="Logo"
				/>
			</a>
		);
	};
	return !isPartnerFBRH() ? partnerContent() : fbrhContent();
};



// WEBPACK FOOTER //
// src/client/components/site/features/partnerships/templates/Media1.js